import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-business',
  imports: [CommonModule],
  templateUrl: './business.component.html',
})
export default class BusinessComponent {}
